import './Pagination.scss';

interface PaginationProps {
  pageIndex: number;
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  disabled?: boolean;
}

/** Dumb presentational pagination — Prev / Page N / Next. */
export default function Pagination({
  pageIndex,
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  disabled,
}: PaginationProps) {
  return (
    <nav className='pagination' aria-label='pagination'>
      <button
        type='button'
        className='pagination__btn'
        onClick={onPrev}
        disabled={disabled || !hasPrev}
        aria-label='Previous page'
      >
        &laquo; Prev
      </button>
      <span className='pagination__label' aria-live='polite'>
        Page {pageIndex + 1}
      </span>
      <button
        type='button'
        className='pagination__btn'
        onClick={onNext}
        disabled={disabled || !hasNext}
        aria-label='Next page'
      >
        Next &raquo;
      </button>
    </nav>
  );
}
